<app-layout>
  <div class="hero-wrapper" #heroHub>
    <app-hero
      [heroType]="'hub'"
      [hubTopic]="topic"
      [hubType]="type"
      [pageTitle]="pageTitle"
      [heroImageSrc]="heroImageSrc"
    ></app-hero>
  </div>
  <app-base-section>
    <app-search *ngIf="topic || type" [topic]="topic" [filterKeywords]="filterKeywords" [type]="type"></app-search>
  </app-base-section>
  <app-presentation
    *ngIf="rootFile"
    [file]="rootFile"
  ></app-presentation>
</app-layout>
